export default "__VITE_ASSET__BhCH_xh5__"